import { Component, Inject, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { AccessManagerService } from '../../auth/accessManager/accessManager.service';
import { AppLinksCfgService } from '../appLinks/appLinksCfg.service';
import { OfficeSelectorService } from '../officeSelector/officeSelector.service';
import { AppLinksProfessionalsCfgService } from '../appLinks/appLinksProfessionalsCfg.service';
import { FeaturePermissionsService } from 'src/app/auth/raas/featurePermissions.service';
import { AppSelectionDialogComponent } from './appSelectionDialog.component';
import { AccessManagerResourceActionType } from '../../auth/accessManager/accessManager.models';
import { AppGroup } from './appGroup';
import { PowerBiDialogComponent } from './powerbi/components/powerbi-dialog/powerbi-dialog.component';
import { ShowPowerBiCfgService } from './powerbi/services/showPowerbi-cfg.service';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';

@Component({
    selector: 'launcher',
    templateUrl: './launcher.component.html',
    host: { 'class': 'px-0' },
    styleUrls: ['./launcher.component.css'],
    standalone: false
})
export class LauncherComponent implements OnInit, OnDestroy {

    @ViewChild(AppSelectionDialogComponent) private appSelector: AppSelectionDialogComponent;
    @ViewChild(PowerBiDialogComponent) private powerBiDialogSelector: PowerBiDialogComponent;

    public readonly groupApps = Array.apply(null, Array(Object.keys(AppGroup).length / 2)).map(() => 0);

    private officeChangedSubscription: Subscription;
    private authTokensChangedSubscription: Subscription;

    constructor(@Inject(DOCUMENT) private document: Document, @Inject(AppLinksCfgService) private appLinksCfgService: AppLinksCfgService,
        private appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
        private officeSelectorService: OfficeSelectorService,
        private showPowerBiCfgService: ShowPowerBiCfgService,
        private apigeeService: ApigeeService, private accessManagerService: AccessManagerService,
        private featurePermissionsService: FeaturePermissionsService) {

    }

    public ngOnInit(): void {
        this.prefetchAppPermissions();
        this.officeChangedSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.prefetchAppPermissions(); });
        this.authTokensChangedSubscription = this.apigeeService.authTokensUpdated.subscribe(() => { this.prefetchAppPermissions(); });
    }

    public ngOnDestroy(): void {
        if (this.officeChangedSubscription) this.officeChangedSubscription.unsubscribe();
        if (this.authTokensChangedSubscription) this.authTokensChangedSubscription.unsubscribe();
    }

    public sideBarMouseEnter() {
        this.document.body.classList.add("bd-sidebar-open");
    }

    public sideBarMouseLeave() {
        this.document.body.classList.remove("bd-sidebar-open");
    }

    /**
     * Determina si muestra la opcion de powerBi o por reportCenter
     * @param event Evento del click
     * @param title Titulo de la opcion
     * @param appGroup Datos del grupo
     */
    public optionReportSelected(event: Event, title: string, appGroup: AppGroup) {
      if (event) event.stopPropagation();
      if (this.showPowerBiCfgService.getCfg().show == "1") {
        this.powerBiDialogSelector.openDialog(title);
      } else {
        this.appSelector.openDialog(title, appGroup);
      }
    }

    public optionSelected(event: Event, title: string, appGroup: AppGroup) {
        if (event) event.stopPropagation();
        this.appSelector.openDialog(title, appGroup);
    }

    public optionPowerBiSelected(event: Event, title: string) {
        if (event) event.stopPropagation();
        this.powerBiDialogSelector.openDialog(title);
    }

    private async prefetchAppPermissions(): Promise<void> {
        this.groupApps.fill(0);
        if (this.officeSelectorService.selectedOffice) {
            if (this.apigeeService.apiToken) {
                let appLinks = (await this.featurePermissionsService.professionalsEnabled() && !this.officeSelectorService.selectedOffice.isTEA) ? this.appLinksProfessionalsCfgService.getCfg().appLinks : this.appLinksCfgService.getCfg().appLinks;
                let promises = appLinks.map(x => {
                    return new Promise<void>((resolve, reject) => {
                        this.accessManagerService.getResourcePermissions(x.resourceId)
                            .then((p) => {
                                if (p.getResourceAction(AccessManagerResourceActionType.WindowAccess)) this.groupApps[x.group]++;
                                resolve();
                            })
                            .catch((error) => reject(error));
                    });
                });
                await Promise.all(promises);
            }
        }
    }

    public openAppMenu(title: string, appGroup: AppGroup) {
        this.appSelector.openDialog(title, appGroup);
    }

    public closeAppMenu() {
        this.appSelector.close();
    }
}
